var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{attrs:{"width":_vm.widthToUse,"height":_vm.heightToUse,"src":_vm.urlVideoSource,"frameborder":"0","allow":"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}})}
var staticRenderFns = []

export { render, staticRenderFns }